export default __webpack_public_path__ + "static/media/success.fc8aef8e.svg";